import * as React from 'react';
import { Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, AlertMessage, AlertType, Form, SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { ManageReferralApi } from '../../../../api/ManageReferralApi';
import { setMessage } from '../../../../helpers/MessageHelper';
import { IReferralShareableInfo } from '../../../../models/IReferral';

interface IReferralShareModal {
    referralId: number;
    renderForm: boolean;
    changeSuccessMessage: (message: string) => void;
    onFormClose: () => void;
    getReferral: (id: number) => void;
}

export const ReferralShareModal: React.FunctionComponent<IReferralShareModal> = ({ referralId, renderForm, changeSuccessMessage, onFormClose, getReferral }) => {

    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const auth = useAuth();
    const manageReferralApi = new ManageReferralApi(auth);
    const [isSharingReferral, setIsSharingReferral] = React.useState<boolean>(false);
    const [shareableCareProvider, setShareableCareProvider] = React.useState<string>("");
    const [isApiFetching, setIsApiFetching] = React.useState<boolean>(false);

    React.useEffect(() => {
        getShareableCareProvider();
    }, [referralId])

    const getShareableCareProvider = () => {
        setIsApiFetching(true);
        manageReferralApi.getShareReferralCareProvider(referralId, (info: IReferralShareableInfo) => {
            setShareableCareProvider(info.careProviderName);
        }, (error: string) => {
            const newMessage = setMessage(error, errorMessage ?? "");
            setErrorMessage(newMessage);
        }, () => { setIsApiFetching(false) })
    }

    const shareReferral = () => {
        setIsSharingReferral(true);
        manageReferralApi.shareReferral(referralId,
            () => {
                changeSuccessMessage("Specialistremissen har delats");
                document.getElementById("close-share-referral-modal")?.click();
                getReferral(referralId);
            },
            (error: string) => {
                const newMessage = setMessage(error, errorMessage ?? "");
                setErrorMessage(newMessage);
            },
            () => {
                setIsSharingReferral(false);
            })
    }

    const closeForm = () => {
        onFormClose();
    }

    return (
        <>
            <Modal header="Dela specialistremiss" modalSize={ModalSize.normal} id="share-referral-modal">
                {
                    renderForm ?
                        <SpinnerWrapper isLoading={isApiFetching}>
                            <Form onSubmit={shareReferral}>
                                <ModalBody>
                                    {
                                        errorMessage.length > 0 ?
                                            <AlertMessage alertType={AlertType.danger} alwaysShow renderOnTopOfPage={false}>{errorMessage}</AlertMessage>
                                            :
                                            <>
                                                <p>Är du säker på att du vill dela specialistremiss med: </p>
                                                <p>{`${shareableCareProvider}`}</p>
                                            </>
                                    }
                                </ModalBody>
                                <ModalFooter>
                                    <CustomButton id="close-share-referral-modal" buttonType={ButtonType.general} onClick={() => closeForm()} buttonText="Avbryt" data-dismiss="modal" />
                                    <CustomSubmitButton isLoading={isSharingReferral} disabled={errorMessage.length > 0}>Dela specialistremiss</CustomSubmitButton>
                                </ModalFooter>
                            </Form>
                        </SpinnerWrapper>
                    : null
                }            
            </Modal>
        </>
    )
}